import MemriseApi from '../MemriseApi';
import {
  LanguagePairLearnablesResponse,
  LanguagePairLearnablesSearchRequest,
  LanguagePairLearnablesSearchResponse,
} from './schema';

export default class LanguageCodePairsApiClass extends MemriseApi {
  constructor() {
    super({ endpointPrefix: '/language_code_pairs' });
  }

  public async getLearnables(
    sourceLanguageLocale: string,
    targetLanguageLocale: string,
  ): Promise<LanguagePairLearnablesResponse> {
    return await this.get(`/${sourceLanguageLocale}/${targetLanguageLocale}/learnables/`);
  }

  public async searchLearnables(
    sourceLanguageLocale: string,
    targetLanguageLocale: string,
    params: LanguagePairLearnablesSearchRequest,
  ): Promise<LanguagePairLearnablesSearchResponse> {
    return await this.get(
      `/${sourceLanguageLocale}/${targetLanguageLocale}/learnables/search/`,
      params,
    );
  }
}

export const LanguageCodePairsApi = new LanguageCodePairsApiClass();
